module.exports = __webpack_public_path__ + "static/media/MilestonesCanvas.135cf459.jpg";